import { apiClient } from './client';
import type { JiraDashboardSummary, JiraProject, JiraSearchResult } from '../types';

export const jiraApi = {
  async getSummary(): Promise<JiraDashboardSummary> {
    const { data } = await apiClient.get<JiraDashboardSummary>('/jira/summary');
    return data;
  },
  async getProjects(): Promise<JiraProject[]> {
    const { data } = await apiClient.get<{ projects: JiraProject[] }>('/jira/projects');
    return data.projects;
  },
  async getIssueTypes(): Promise<string[]> {
    const { data } = await apiClient.get<{ issueTypes: string[] }>('/jira/issue-types');
    return data.issueTypes;
  },
  async getIssues(params: {
    projectKey?: string;
    status?: string;
    issueType?: string;
    query?: string;
    maxResults?: number;
    startAt?: number;
  }): Promise<JiraSearchResult> {
    const { data } = await apiClient.get<JiraSearchResult>('/jira/issues', { params });
    return data;
  },
};